export default "__VITE_ASSET__CblpM4vI__"